import React, { useState, useEffect } from 'react';
import request from '@/services/request.service';
import { useLocation } from 'react-router-dom';
import { toFormData } from '@/utils/convert.util';

import Tab from './Tab';
import SendHistory from './SendHistory';
import PayHistory from './PayHistory';

export default function SendPayHistory() {
    const location = useLocation();
    const [tab, setTab] = useState(0);
    const [list, setLst] = useState([]);
    const [list2, setLst2] = useState([]);

    const param = location.search;

    const fetchBusinesses = () => {
        getList();
        getList2();
        if (param === '?tab1') {
            setTab(0);
        } else if (param === '?tab2') {
            setTab(1);
        }
    };
    useEffect(fetchBusinesses, [param]);

    const getList = async () => {
        const param = { m_code: 1000218, coin: 'POINT' };
        const rsp = await request
            .post('/api/funds/deposit_list.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            alert(rsp.msg);
            return rsp;
        } else {
            setLst(rsp.list);
        }
    };
    const getList2 = async () => {
        const param = { m_code: 1000005, coin: 'POINT' };
        const rsp = await request
            .post('/api/funds/withdraw_list.php', toFormData(param))
            .then((response) => response.data);
        if (rsp.result < 0) {
            alert(rsp.msg);
            return rsp;
        } else {
            setLst2(rsp.list);
        }
    };

    return (
        <>
            <Tab tab={tab} setTab={setTab} getList={getList} getList2={getList2} />
            <div className="history_box history_box01 t_pur">
                <div className="table_body">
                    {tab === 0 ? <SendHistory list={list} /> : null}
                    {tab === 1 ? <PayHistory list={list2} /> : null}
                </div>
            </div>
        </>
    );
}
